import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../../services/general.service';
import { ProvidersService } from '../../../services/providers.service';
import * as decode from 'jwt-decode';
//import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-provider-companies',
  templateUrl: './provider-companies.component.html',
  styleUrls: ['./provider-companies.component.scss']
})
export class ProviderCompaniesComponent implements OnInit {
  userToken: any;
  userId: any;
  type: any;
  info: any = {};
  provider: any;
  txtHead: string;
  loadBtn = false;
  typeUse: any;
  valUse: any;
  providerId: any;
  listSocieties = [];

  constructor(private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any> , public dialogRef: MatDialogRef<ProviderCompaniesComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userToken = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.providerId = this.data.provider;
    this.type = this.data.type; //companies
    this.info = this.data.info; //datos del proveeddor

    //this.info.Sociedades

    translate.onLangChange.subscribe(lang => {
      if (lang.lang == 'en') {
        this.adapter.setLocale('en-GB');
      }

      if (lang.lang == 'es') {
        this.adapter.setLocale('es-MX');
      }
    });

    this.getSocieties();
  }

  ngOnInit() {
  }

  getSocieties() {
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if (data['EsValido']) {
        this.listSocieties = data['Entidades'];
        if (this.listSocieties.length == 1) {

          //this.info.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      } else {
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety() {
    /*
    const society = this.listSocieties.find(x => x.NoSociedad == this.sendInfo.Sociedad);
    if (society.NumProveedor) {
      //this.sendInfo.NumProveedor = society.NumProveedor;
    }
    */
  }

  save() {
    this.loadBtn = true;
    this.info.IdProveedor = this.providerId;

    var params = {
      IdProveedor: this.providerId,
      Sociedades: []
    };

    for (var i = 0; i < this.info.Sociedades.length ; i++ )
    {
      params.Sociedades.push({
        NoSociedad: "",
        NumeroProveedor: "",
        Activo: true
      });
    }

    this.provService.sendCompanies(this.providerId, params, this.userToken).then((data) => {
      if (data['EsValido']) {
        this.toastr.success('Configuración guardada correctamente', 'Parámetros de Proveedor');
        this.dialogRef.close();
      } else {
        this.toastr.error(data['MensajeUsuario'], 'Parámetros de Proveedor');
        return;
      }
      this.loadBtn = false;
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

}
